import script from "./FeedbackP.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackP.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackP.vue?vue&type=style&index=0&id=2913faac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2913faac"]])

export default __exports__